import { dataCurveSquare } from 'dls-icons-data'
import { createIcon } from '../common'

const IconCurveSquare = /*#__PURE__*/createIcon(dataCurveSquare)
export default IconCurveSquare
